module.exports = __webpack_public_path__ + "static/media/plan_process_two.e932d8d6.svg";